// extracted by mini-css-extract-plugin
module.exports = {"root":"global_root__1hJxB","fontHeight":"global_fontHeight__3w9mN","infinite-scroll-component":"global_infinite-scroll-component__3WV6_"};